import React from 'react';
import { ApprenticeSelector } from '../components/apprentices/ApprenticeSelector';
import { generateProgressPDF } from '../lib/pdf';
import { buildLevels } from '../lib/helpers';

export function ReportsPage({ profile, myApprentices, selApprId, setSelApprId, allProfiles, evidence, signoffs, workplaceSignoffs, knowledgeUnits, trainingPlans, tradeSchoolLogs, kanganLogs, levelDates, units }) {
  const activeId = profile.role === 'apprentice' ? profile.id : selApprId;
  const appr = allProfiles.find(p => p.id === activeId);

  async function downloadReport() {
    if (!appr) return;
    await generateProgressPDF(appr, {
      allProfiles,
      evidence,
      signoffs,
      workplaceSignoffs,
      knowledgeUnits,
      trainingPlans: trainingPlans.filter(p => p.apprentice_id === appr.id),
      tradeSchoolLogs: tradeSchoolLogs.filter(l => l.apprentice_id === appr.id),
      kanganLogs: kanganLogs.filter(l => l.apprentice_id === appr.id),
      levelDates,
      units,
      buildLevelsFn: buildLevels,
    });
  }

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Reports</div>
          <div className="page-sub">Generate progress reports for apprentices</div>
        </div>
      </div>

      {profile.role !== 'apprentice' && (
        <ApprenticeSelector apprentices={myApprentices} active={selApprId} onChange={setSelApprId} />
      )}

      {!activeId ? (
        <div className="empty"><div className="empty-icon">📊</div><p>Select an apprentice to generate a report</p></div>
      ) : (
        <div className="card">
          <div className="card-hdr">
            <span className="card-title">Progress Report — {appr?.name || 'Unknown'}</span>
          </div>
          <div style={{ padding: 20 }}>
            <p style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.7, marginBottom: 16 }}>
              Generates a comprehensive PDF progress report including unit completion status, 
              evidence summary, trade school hours, Kangan workplace visits, and timeline progress.
              {/* FIX #7: trainer contact info included in PDF */}
            </p>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button className="btn" onClick={downloadReport}>
                ⬇ Download Progress Report
              </button>
            </div>

            <div className="infobox" style={{ marginTop: 16 }}>
              <strong>Included in report:</strong> Unit completion by level, approved evidence count per unit, 
              trade school hours summary, Kangan visits log, trainer/supervisor contact details, timeline alerts.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
